// extracted by mini-css-extract-plugin
export default {"history":"MetricContent_history__0TD1n","section_summary":"MetricContent_section_summary__1cbD8"};